import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

interface FAQItem { q: string; a: string; }

export const FAQ = ({ items, title }: { items: FAQItem[]; title?: string }) => {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-24 bg-background">
      <div className="container max-w-3xl">
        <h2 className="font-display text-4xl md:text-5xl text-primary mb-8 text-center">
          {title ?? t("section.faq.title")}
        </h2>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`f-${i}`} className="bg-card border border-border rounded-xl px-5">
              <AccordionTrigger className="text-left font-semibold text-primary hover:no-underline">{it.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};